var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-nav"},_vm._l((_vm.links),function(link){return _c('EventLink',{key:link,staticClass:"nav-item text6",attrs:{"id":`link--header-link-${link}`,"event":_vm.getEventNameFromLink(link),"slug":_vm.getEventSlugFromLink(link)}},[_vm._v(" "+_vm._s(_vm.$t(`common.menu.links.${link}`))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }